<template>
  <div class="login-phone-code-container">
    <div class="content">
      <div class="head">
        <div class="close" @click="$router.back()"></div>
        <div class="title">验证码</div>
      </div>
      <div class="box">
        <div class="t1">请输入验证码</div>
        <div class="t2">
          <span>已发送至+86 {{ phone_c }}</span>
          <span class="codeTimeout" v-if="code_flag"
            >{{ code_timeout }}s 后重新发送</span
          >
          <template v-else>
            <Loading class="resendLoading" v-if="loading" />
            <span class="resend" v-else @click="resend">{{ whenSend }}</span>
          </template>
        </div>
        <div class="form">
          <PasswordInput
            :value="code"
            :length="6"
            :focused="showKeyboard"
            :mask="false"
            @focus="showKeyboard = true"
          />
          <input type="number" max="999999" v-model="code" />
        </div>
        <div class="other" v-if="type === 'code_login'">
          <span @click="toPasswordLogin">密码登录</span>
        </div>
      </div>
    </div>
    <!-- <NumberKeyboard
      v-model="code"
      :show="showKeyboard"
      @blur="showKeyboard = false"
    /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  forgetPassword,
  registerCustomer,
  getBindWechatInfo,
} from "@/api/login";
import { PasswordInput, NumberKeyboard, Loading, Toast, Dialog } from "vant";
import { isWechat } from "@/utils/auth";
export default {
  components: { PasswordInput, Loading },
  // components: { PasswordInput, NumberKeyboard, Loading },
  data() {
    return {
      loading: false,
      phone: this.$route.query.phone,
      type: this.$route.query.type,
      newPassword: this.$route.query.newPassword,
      code: "",
      showKeyboard: false,
      redirect: undefined,
      otherQuery: {},
      whenSend: "立即发送",
    };
  },
  computed: {
    ...mapState({
      code_timeout: (state) => state.sms.code_timeout,
      code_flag: (state) => state.sms.code_flag,
    }),
    phone_c() {
      return this.phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    },
  },
  watch: {
    code(val) {
      setTimeout(() => {
        const dom = document.querySelectorAll(".van-password-input__item");
        for (let i = 0; i < 6; i++) {
          if (i <= val.length - 1) {
            dom[i].classList.add("active");
          } else {
            dom[i].classList.remove("active");
          }
        }
      }, 50);
      if (val.length === 6) {
        this.handleClick();
      }
    },
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  methods: {
    resend() {
      this.loading = true;
      if (this.type === "code_login") {
        this.$store
          .dispatch("sms/loginSendCode", this.phone)
          .then((res) => {
            this.loading = false;
            this.whenSend = "重新发送";
            Toast.success("已发送验证码");
          })
          .catch(() => {
            this.loading = false;
          });
      }
      if (this.type === "code_register") {
        this.$store
          .dispatch("sms/loginRegisterCode", this.phone)
          .then((res) => {
            this.loading = false;
            this.whenSend = "重新发送";
            Toast.success("已发送验证码");
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    handleClick() {
      this.showKeyboard = false;
      if (this.type === "code_login") {
        this.login();
      }
      if (this.type === "forget_password") {
        this.forget();
      }
      if (this.type === "code_register") {
        setTimeout(() => {
          this.registerNext();
        }, 500); // 等待输入框下划线动画结束
      }
    },
    forget() {
      const params = {
        code: this.code,
        mobile: this.phone,
        password: this.newPassword,
      };
      this.$store.dispatch("app/showLoading");
      forgetPassword(params)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.$store.dispatch("user/resetToken");
          this.$store.dispatch("sms/resetCode");
          Toast.success("重置密码成功");
          this.$router.push({
            name: "LoginPhonePassword",
            query: { phone: this.phone },
          });
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    login() {
      const params = new FormData();
      params.append("mobile", this.phone);
      params.append("code", this.code);
      params.append("scope", "h5");
      params.append("grant_type", "mobile_code");
      this.$store.dispatch("app/showLoading");
      this.$store
        .dispatch("user/loginPhonePassword", params)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.$store.dispatch("sms/resetCode");
          // Toast.success('登录成功')
          console.log("this.redirect", this.redirect);
          if (this.redirect && this.redirect !== "/") {
            this.$router.push({
              path: this.redirect,
              query: this.otherQuery,
            });
          } else {
            return getBindWechatInfo();
          }
        })
        .then((res) => {

          if (!res) return false;
          if (!isWechat() || res.data) {
            this.$router.push("/");
          } else {
            Dialog.confirm({
              message: `您的手机号还未绑定微信<br/>绑定微信有助您账户安全 请绑定微信`,
              theme: "round-button",
              confirmButtonText: "去绑定",
              cancelButtonText: "取消",
              showCancelButton: true,
              closeOnClickOverlay: true,
              beforeClose: (action, done) => {
                if (action === "confirm") {
                  done();
                  this.$router.push({
                    path: "/mine/setting",
                  });
                } else {
                  done();
                  this.$router.push("/");
                }
              },
            }).catch(() => {});
          }
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
          this.code = "";
        });
    },
    registerNext() {
      const code_flag = this.code.length === 6 ? true : false;
      if (code_flag) {
        this.$router.push({
          name: "RegisterPassword",
          query: {
            ...this.$route.query,
            code: this.code,
          },
        });
      } else {
        if (this.code.length === 12) {
          const code = this.code.substring(6);
          this.code = code;
          this.$router.push({
            name: "RegisterPassword",
            query: {
              ...this.$route.query,
              code: this.code,
            },
          });
        } else {
          Toast.fail("请输入正确的验证码");
          Toast.fail(`验证码错误 ${this.code}`);
        }
      }
    },
    toPasswordLogin() {
      this.$router.replace({
        name: "LoginPhonePassword",
        query: { ...this.$route.query, phone: this.phone },
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
  },
};
</script>

<style lang="less" scoped>
.close {
  display: inline-block;
  width: 30px;
  height: 4px;
  background: #333;
  border-radius: 4px;
  transform: rotate(45deg);

  &::after {
    content: "";
    display: block;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 4px;
    transform: rotate(-90deg);
  }
}

.login-phone-code-container {
  height: 100vh;
  width: 100vw;

  .content {
    width: 100%;
    padding: 0 40px;
  }

  .head {
    display: flex;
    align-items: center;
    padding: 30px 0;

    .title {
      flex: 1;
      font-size: 28px;
      line-height: 1;
      text-indent: -20px;
    }
  }

  .box {
    text-align: left;
    padding-top: 40px;

    .t1 {
      font-size: 36px;
      line-height: 1em;
      padding-bottom: 18px;
    }

    .t2 {
      color: #808080;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .resend {
        color: #e82035;
        font-size: 28px;
      }

      .resendLoading /deep/ .van-loading__spinner {
        width: 42px;
        height: 42px;
      }

      .codeTimeout {
        font-size: 28px;
      }
    }

    .form {
      .van-password-input {
        margin: 0;

        .van-password-input__security::after {
          border: none;
        }
      }

      position: relative;
      input {
        width: 80%;
        height: 300px;
        position: relative;
        top: -200px;
        left: 0;
        background: transparent;
        color: transparent;
      }
    }

    .other {
      text-align: center;
      font-size: 26px;
      line-height: 36px;
      padding-top: 108px;

      span {
        color: #aeaeae;
      }
    }

    .btn {
      margin-top: 80px;
      width: 100%;
      background: #e82035;
      line-height: 82px;
      border-radius: 50px;
      font-size: 26px;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
<style lang="less">
.van-password-input__item {
  margin: 0 14px;

  &::before {
    position: absolute;
    bottom: 0;
    content: "";
    left: 0;
    height: 1px;
    background: #333333;
    z-index: 9;
    width: 0;
    transition: 0.3s;
  }

  &.active::before {
    width: 100%;
  }

  &::after {
    position: absolute;
    content: "";
    border-bottom: 1px solid #aeaeae;
    border-left-width: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transform: none;
  }
}
</style>
